import { Component, Inject } from "@angular/core";
import { MdDialogRef, MD_DIALOG_DATA } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductReleaseService } from "../../services/ProductReleaseService";
import { Subscription } from "rxjs/Subscription";
import { AdalService } from "../../shared/adal.service";
import { UserService } from "../../services/UserService";
import * as moment from 'moment';

@Component({
  selector: "dialog-result-example-dialog",
  template: require('./userrightssummary.component.html'),
  styles: [require('./userrightssummary.component.css')],
})
export class PageLayoutUserRightsSummaryComponent {
  private sub: Subscription;
  Title: string;
  userrightssummary: any;
  summaryText: any[] = [];
  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private adalService: AdalService,
    private userService: UserService,
    public dialogRef: MdDialogRef<PageLayoutUserRightsSummaryComponent>,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    //Check Authentication
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close();
      this.router.navigate(["login"]);
    }

    if (this.data.UserName != "")
      this.Title = this.data.UserName + " - User rights change history";
    else this.Title = "";
    this.getUserRightsSummary(this.data.userId);
  }

  getUserRightsSummary(userId: number) {
    this.userService.getUserRightsDetaisSummaryById(userId).subscribe(
      (data) => {
        
        this.userrightssummary = data.DataObject;
      },
      (error) => {
        this.errorMessage = error;
      }
    );
  }

  UTCToLocalTimeZone(date) {
    
    //let theDate = new Date(Date.parse(date));
    var stillUtc = moment.utc(date).toDate();
    let theDate = moment(stillUtc).local();
    return theDate.toLocaleString();
  }

  onCancel(): void {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-management/user-rights-summary/userrightssummary.component.ts